/* Mobile product-page space. Reuse the translated announcement and real buy
   actions; do not create a second banner, form or copy of the product data. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 749px)');
  var announcement, originalPlace, host, pending;
  var lastY = window.scrollY, travel = 0, direction = 0, keepHeaderUntil = 0;

  function setClass(element, name, on) {
    if (element.classList.contains(name) !== on) element.classList.toggle(name, on);
  }

  function visible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    var style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
      rect.top < window.innerHeight && style.visibility !== 'hidden' && style.display !== 'none';
  }

  function overlayOpen() {
    return /overflow-hidden/.test(document.body.className) ||
      !!document.querySelector('#ke-kop details[open], cart-drawer.active') ||
      visible(document.getElementById('shopify-pc__prefs__dialog'));
  }

  function updateHeader() {
    var y = Math.max(0, window.scrollY);
    var delta = y - lastY;
    lastY = y;
    if (!mobile.matches || y < 80 || overlayOpen() || Date.now() < keepHeaderUntil) {
      setClass(document.body, 'ke-mobile-header-hidden', false);
      travel = 0; direction = 0;
      return;
    }
    if (Math.abs(delta) < 1) return;
    var nextDirection = delta > 0 ? 1 : -1;
    if (nextDirection !== direction) { direction = nextDirection; travel = 0; }
    travel += Math.abs(delta);
    if (travel >= (direction > 0 ? 24 : 12)) {
      setClass(document.body, 'ke-mobile-header-hidden', direction > 0);
      travel = 0;
    }
  }

  function arrange() {
    var main = document.getElementById('MainContent');
    var header = document.getElementById('ke-kop');
    if (!main || main.dataset.template !== 'product' || !header) return;

    if (!announcement || !announcement.isConnected) {
      announcement = header.querySelector('.kopero-announcement');
      if (!announcement) return;
      originalPlace = document.createComment('Kopero announcement desktop position');
      announcement.parentNode.insertBefore(originalPlace, announcement);
    }

    if (mobile.matches) {
      var product = main.querySelector('product-info');
      var section = product && product.closest('.shopify-section');
      if (!section) return;
      host = main.querySelector('.ke-product-mobile-announcement');
      if (!host) {
        host = document.createElement('div');
        host.className = 'ke-product-mobile-announcement';
        section.insertAdjacentElement('afterend', host);
      }
      if (announcement.parentNode !== host) host.appendChild(announcement);
    } else {
      if (originalPlace && originalPlace.parentNode && announcement.previousSibling !== originalPlace) {
        originalPlace.parentNode.insertBefore(announcement, originalPlace.nextSibling);
      }
      if (host) { host.remove(); host = null; }
    }
    measure();
  }

  function measure() {
    pending = false;
    updateHeader();
    var bar = document.querySelector('[data-kopero-koopbalk]');
    if (!bar) return;
    if (!mobile.matches) {
      bar.classList.remove('ke-mobile-buy-visible');
      document.body.classList.remove('ke-mobile-wa-visible');
      document.documentElement.style.removeProperty('--ke-mobile-buybar-height');
      return;
    }
    var header = document.getElementById('ke-kop');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var buttons = document.querySelectorAll('#MainContent form[action*="/cart/add"] button[type="submit"], #MainContent .product-form__submit');
    var anotherBuyVisible = Array.prototype.some.call(buttons, function (button) {
      if (bar.contains(button)) return false;
      var rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 &&
        rect.bottom > top + 8 && rect.top < window.innerHeight - 8 &&
        getComputedStyle(button).visibility !== 'hidden';
    });
    setClass(bar, 'ke-mobile-buy-visible', anotherBuyVisible);
    var barVisible = bar.classList.contains('ke-aan') && !bar.classList.contains('ke-na-footer') &&
      !anotherBuyVisible && visible(bar);
    var height = bar.offsetHeight + 'px';
    if (document.documentElement.style.getPropertyValue('--ke-mobile-buybar-height') !== height) {
      document.documentElement.style.setProperty('--ke-mobile-buybar-height', height);
    }
    setClass(document.body, 'ke-mobile-wa-visible', barVisible && !overlayOpen() &&
      !visible(document.getElementById('shopify-pc__banner')));
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(measure, 80);
  }

  function init() {
    arrange();
    var bar = document.querySelector('[data-kopero-koopbalk]');
    if (bar) new MutationObserver(schedule).observe(bar, { attributes: true, attributeFilter: ['class'] });
    /* Header/menu and native privacy UI can change without a scroll event. */
    new MutationObserver(schedule).observe(document.body, { childList: true });
    new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('toggle', schedule, true);
    document.addEventListener('visitorConsentCollected', schedule);
    document.addEventListener('click', function (event) {
      if (mobile.matches && event.target.closest('.ke-sprong a')) {
        keepHeaderUntil = Date.now() + 1200;
        setClass(document.body, 'ke-mobile-header-hidden', false);
        travel = 0; direction = 0;
      }
      schedule();
    }, true);
    document.addEventListener('focusin', function (event) {
      if (event.target.closest('#ke-kop')) {
        keepHeaderUntil = Date.now() + 1200;
        setClass(document.body, 'ke-mobile-header-hidden', false);
      }
    });
    document.addEventListener('shopify:section:load', arrange);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', arrange);
    if (mobile.addEventListener) mobile.addEventListener('change', arrange);
    else mobile.addListener(arrange);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
